import {
    LazyModule,
    createLazyComponent,
    LazyModuleType,
    LazyAction,
    LazyImport,
} from 'owa-bundling';
import { Loading, NetworkError } from 'owa-timestream-loadingpanel';
import type { AssetId } from 'owa-timestream-types';
import type { TimeStreamCanvasProps, TimeStreamCanvasPreviewProps } from './schema';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "TimeStreamCanvas" */ './lazyIndex')
);

export function preLoadTimeStreamCanvas() {
    lazyModule.import();
}

export const LazyTimeStreamCanvas = createLazyComponent<
    TimeStreamCanvasProps,
    LazyModuleType<typeof lazyModule>,
    {}
>(lazyModule, m => m.TimeStreamCanvas, Loading, NetworkError);

export const LazyTimeStreamCanvasPreview = createLazyComponent<
    TimeStreamCanvasPreviewProps,
    LazyModuleType<typeof lazyModule>,
    {}
>(lazyModule, m => m.TimeStreamCanvasPreview);

// TODO VSO 106628: decouple the canvas from the asset creation views (I.e toolbox/ menu)
export const lazyGetTimeStreamAssetMenuItem = new LazyImport(
    lazyModule,
    m => m.getTimeStreamAssetMenuItem
);

let lazyClearSelectedAssets = new LazyAction(lazyModule, m => m.clearSelectedAssets);
export function clearSelectedAssets() {
    lazyClearSelectedAssets.importAndExecute();
}

let lazyDeleteSelectedAssets = new LazyAction(lazyModule, m => m.deleteSelectedAssets);
export function deleteSelectedAssets() {
    lazyDeleteSelectedAssets.importAndExecute();
}

let lazyGetSelectedAssets = new LazyImport(lazyModule, m => m.getSelectedAssets);
export function getSelectedAssets(): AssetId[] {
    const getAssets = lazyGetSelectedAssets.tryImportForRender();
    return getAssets ? getAssets() : [];
}

let lazyGetLockCanvas = new LazyImport(lazyModule, m => m.isCanvasLocked);
export function isCanvasLocked(): boolean {
    const lockCanvas = lazyGetLockCanvas.tryImportForRender();
    return !!lockCanvas?.();
}

export { FirstRunExperienceProvider } from './hooks/useFirstRunExperience';
export { ProjectsToolboxProvider } from './hooks/useProjectsToolbox';
export { ActivityPaneProvider } from './hooks/useActivityPaneContext';

import './orchestrators/onAssetsLoadedOrchestrator';
